var map = {
	"./Jam1.svg": 602,
	"./Jam2.svg": 603,
	"./Jam3.svg": 604,
	"./Jam4.svg": 605,
	"./Jam5.svg": 606,
	"./Jam6.svg": 607,
	"./Jam7.svg": 608,
	"./Jam8.svg": 609,
	"./Jam9.svg": 610
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos ^\.\/Jam.*\.svg$
// module id = 312
// module chunks = 0